import {
  GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200ClientFeatureFlagsItem,
  PostApiV1ThreeLetterCodePartnerAdminsClientsBody,
} from '@fukuri-admins/apis/client/gen/model';
import { CreateClientFormFieldValues } from '../schema';

type Args = {
  formValues: CreateClientFormFieldValues;
  featureFlags: GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200ClientFeatureFlagsItem[];
};

type IGenerateRequest = (args: Args) => PostApiV1ThreeLetterCodePartnerAdminsClientsBody;

/**
 * 文字列を number[] に変換する
 */
const parseOptionalNumberList = (val: string | undefined): number[] => {
  if (!val) return [];
  const parsed = Number.parseInt(val, 10);
  return Number.isNaN(parsed) ? [] : [parsed];
};

/**
 * 選択済みフィーチャーフラグを { feature_key: boolean } の形式に変換する
 * - selectedFlags に含まれるキーは true、含まれないキーは false となる
 */
const parseFeatureFlags = (
  selectedFlags: string[],
  featureFlags: GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200ClientFeatureFlagsItem[]
): Record<string, boolean> => {
  return featureFlags.reduce(
    (acc, flag) => {
      acc[flag.feature_key] = selectedFlags.includes(flag.feature_key);
      return acc;
    },
    {} as Record<string, boolean>
  );
};

/**
 * フォームの値からAPIリクエストボディを生成する
 *
 * NOTE: `gift_plan_id` はギフトプラン選択UIを廃止したため常に null を送信する。
 * バックエンドAPI（POST /partner_admins/clients）は `gift_plan_id`（nullable）を
 * リクエストボディの必須キーとして要求するため、キー自体を省略することはできない。
 */
export const generateRequest: IGenerateRequest = ({ formValues, featureFlags }) => {
  const {
    name,
    contactPersonName,
    contactPersonEmail,
    contactPersonPhone,
    corporateNumber,
    externalClientId,
    groupId,
    employeeCount,
    clientFeatureFlags,
  } = formValues;

  return {
    client: {
      name,
      contact_person_name: contactPersonName,
      contact_person_email: contactPersonEmail,
      contact_person_phone: contactPersonPhone,
      corporate_number: corporateNumber || undefined,
      external_client_id: externalClientId || undefined,
      employee_count: employeeCount,
      group_ids: parseOptionalNumberList(groupId),
      gift_plan_id: null,
      custom_field_values: [],
      client_feature_flags: parseFeatureFlags(clientFeatureFlags ?? [], featureFlags),
    },
  };
};
